import {
  createDocument,
  getAllData,
  getById,
  updateDocumentByID,
} from "apis/customApiHandler";
import Modal from "components/Modal";
import Spinner from "components/Spinner";
import useDebounce from "hooks/useDebounce";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useQuery } from "react-query";
import ReactSelect from "react-select";
import { Button, Input, Select } from "styled";
import { TD, TH } from "styled/table";
import getFormattedDate, {
  convertToIndianTimezoneAndGetDate,
} from "utils/helpers";
import { IoMdArrowBack, IoMdArrowForward } from "react-icons/io";
import { BiCheck, BiCloudDownload, BiTransferAlt } from "react-icons/bi";
import { AiOutlineClose } from "react-icons/ai";
import { FaCheck } from "react-icons/fa";
import { RiCloseFill, RiCloseLine } from "react-icons/ri";
import toast from "react-hot-toast";
import { useSearchParams } from "react-router-dom";
import checkPermission from "utils/checkPermission";
import permissions from "utils/permissionConstants";
import { useSelector } from "react-redux";
import { Form, FormikProvider, useFormik } from "formik";
import exportExcel from "utils/exportExcel";

const ExternalStockTansferReport = () => {
  const currentUser = useSelector((state) => state.user.currentUser);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [transferTyres, setTransferTyres] = useState(null);
  const [selectedFleets, setSelectedFleets] = useState([]);
  const [selectedHubs, setSelectedHubs] = useState([]);
  const [selectedFleetsTo, setSelectedFleetsTo] = useState([]);
  const [selectedHubsTo, setSelectedHubsTo] = useState([]);
  const [contractType,setContractType]=useState();
  const [stockTransferType,setStockTransferType]=useState();
  const [fleetMap, setFleetMap] = useState({});
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const [id, setId] = useState("");
  const [request, setRequest] = useState({});
  const [downloading, setDownloading] = useState(false);
  const [downloadData, setDownloadData] = useState([]);

  useEffect(() => {
    setId(searchParams.get("_id"));
  }, [searchParams]);

  useMemo(async () => {
    if (id) {
      const response = await getById("/tyre/externalStockTransfer", id);
      setRequest(response.data);
    }
  }, [id]);

  const limit = 20;
  const { data: allFleets } = useQuery([`/customer-fleet`], () =>
    getAllData("/customer-fleet", {
      limit: 3000,
    })
  );
  const { data: allHubs } = useQuery([`/customer-hub`], () =>
    getAllData("/customer-hub", {
      limit: 3000,
    })
  );

  const { data: allFleetsTo } = useQuery([`/customer-fleet-to`], () =>
    getAllData("/customer-fleet", {
      limit: 3000,
      fromUsers: 1,
    })
  );
  const { data: allHubsTo } = useQuery([`/customer-hub-to`], () =>
    getAllData("/customer-hub", {
      limit: 3000,
      ignoreAssignedHubs: 1,
    })
  );

  useEffect(()=>{
    if((selectedHubs?.length || selectedHubsTo?.length)) getData();
  }, [page])

  const getData = async (pg, download = false) => {
    if(download) setDownloading(true);
    else setLoading(true);
    try {
      const response = await createDocument("/tyre/externalStockTansfers", {
        searchQuery: search,

        ...(selectedFleets?.includes("all")
          ? {
              fromFleet: getFleetOptions().filter(item => item.value!== "all" && item.value!== "clear")
              .map((item) => item.value)
                .join(","),
            }
          : selectedFleets.length && {
              fromFleet: selectedFleets.map((fleet) => fleet).join(","),
            }),
        ...(selectedHubs?.includes("all")
          ? {
              fromHub: getHubOptions().filter(item => item.value!== "all" && item.value!== "clear")
                .map((item) => item.value)
                .join(","),
            }
          : selectedHubs.length && {
              fromHub: selectedHubs.map((hub) => hub).join(","),
            }),

        ...(selectedFleetsTo?.includes("all")
          ? {
              toFleet: getToFleetOptions().filter(item => item.value!== "all" && item.value!== "clear")
            .map((item) => item.value)
                .join(","),
            }
          : selectedFleetsTo.length && {
              toFleet: selectedFleetsTo.map((fleet) => fleet).join(","),
            }),
        ...(selectedHubsTo?.includes("all")
          ? {
              toHub: getToHubOptions().filter(item => item.value!== "all" && item.value!== "clear")
                .map((item) => item.value)
                .join(","),
            }
          : selectedHubsTo.length && {
              toHub: selectedHubsTo.map((hub) => hub).join(","),
            }),
            ...(contractType ? {contractType: contractType}:{}),
            ...(stockTransferType? {type:stockTransferType}:{}),
        dateFrom,
        dateTo,
        page: pg ? pg : page,
        // download: 0,
        limit: limit,
        download,
        status: "TRANSFERED",
      });

      if (download && response?.data) {
        let count=0;
        const flattenedData = response.data.flatMap((entry) => {
         const tyreData = entry.tyres?.length ? entry?.tyres : entry.stencilDetails
        return tyreData.map((tyre, index) => ({
          "S No":++count,
          Date: convertToIndianTimezoneAndGetDate(entry.createdAt),
          "From Fleet": `${entry.fromFleet} (${entry.fromFleetCity})`,
          "From Hub": entry.fromHub,
          "To Fleet": `${entry.toFleet} (${entry.toFleetCity})`,
          "To Hub": entry.toHub,
          Reason: entry.reason,
          Status: entry.status, 
          "Tyre Type": tyre.tyreType ? tyre.tyreType: "ITM",
          "Stencil Number": tyre.stencilNo,
          "Average NSD": tyre.averageNSD ? parseFloat(tyre.averageNSD):0,
          "Updated By": entry.updatedBy,
          "Material": tyre.productName ?? (tyre.productInfo ? tyre.productInfo.productName : tyre.productMasterInfo ? tyre.productMasterInfo.productName : "N/A"),
          "Size": tyre.tyreSize ?? (tyre.productInfo ? tyre.productInfo.tyreSize : tyre.productMasterInfo ? tyre.productMasterInfo.tyreSize : "N/A"),
          "Original NSD": tyre.originalNSD ? parseFloat(tyre.originalNSD): (tyre.productInfo ? parseFloat(tyre.productInfo.originalNSD) :0),
          "NDP Tyre": tyre.NDPTyre ? parseFloat(tyre.NDPTyre):0,
          "NDP Tube":tyre.NDPTube  ? parseFloat(tyre.NDPTube):0,
          "NDP Flap":tyre.NDPFlap ? parseFloat(tyre.NDPFlap):0,
          "Amount": tyre.amount ? parseFloat(tyre.amount):0,
          "Discount (%)":tyre.discount ? parseFloat(tyre.discount):0,
          "After Discount":tyre.afterDiscount ? parseFloat(tyre.afterDiscount):0,
          "Contract Type":entry.contractType,
          "Stock Transfer Type":entry.type,
          "Approved By": entry.status === "TRANSFERED" ? (entry.transferedBy ? entry.transferedBy : entry.updatedBy) : (entry.approvedBy ? entry.approvedBy: null),

        }));
      });
        // exportExcel(
        //   response.data.map((entry) => ({
        //     Date: convertToIndianTimezoneAndGetDate(entry.createdAt),
        //     "From Fleet": entry.fromFleet,
        //     "From Hub": entry.fromHub,
        //     "To Fleet": entry.toFleet,
        //     "To Hub": entry.toHub,
        //     Reason: entry.reason,
        //     Status: entry.status,
        //     "No of Tyres": entry.tyres?.length > 0  ? entry.tyres.length : (entry.stencilDetails?.length ?? 0),
        //     "Updated By": entry.updatedBy,
        //   })),
        //   "stock-transfers"
        // );
        exportExcel(flattenedData,"stock-transfers");
      }
      if(!download) setData(response);
      }
     catch (err) {}
    finally {
      if(download) setDownloading(false);
      else setLoading(false);  
    }
  };

  const getFleetOptions = useCallback(() => {
    if (allFleets && allFleets.data && allFleets.data.length) {
      return [
        {
          label: "All",
          value: "all",
        },
        {
          label: "Clear",
          value: "clear",
        },
        ...allFleets?.data?.map((fleet) => {
          return {
            value: fleet._id,
            label: fleet.fleetName,
          };
        }),
      ];
    }
  }, [allFleets]);

  const getHubOptions = useCallback(() => {
    if (allHubs && allHubs.data && allHubs.data.length) {
      return [
       ...selectedFleets?.length ? [{
          label: "All",
          value: "all",
        }]: [],
        ...selectedFleets?.length ? [{
          label: "Clear",
          value: "clear",
        }]: [],
        ...(selectedFleets?.includes("all") ? 
        allHubs?.data?.length &&
          allHubs?.data
            ?.map((hub) => {
              return {
                value: hub._id,
                label: hub.hubName,
              };
            }) : 
        allHubs?.data?.length &&
          allHubs?.data
            ?.filter((hub) => {
              const selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                selectedFleets?.includes(fleet._id)
              );

              return selectedFleetsVal?.some(
                (fleet) => fleet.fleetCode === hub.fleetCode
              );
            })
            ?.map((hub) => {
              return {
                value: hub._id,
                label: hub.hubName,
              };
            })),
      ];
    }
  }, [allFleets, allHubs, selectedFleets]);

  const getToFleetOptions = useCallback(() => {
    if (allFleetsTo && allFleetsTo.data && allFleetsTo.data.length) {
      return [
        {
          label: "All",
          value: "all",
        },
        {
          label: "Clear",
          value: "clear",
        },
        ...allFleetsTo?.data?.map((fleet) => {
          return {
            value: fleet._id,
            label: fleet.fleetName,
          };
        }),
      ];
    }
  }, [allFleetsTo]);

  const getToHubOptions = useCallback(() => {
    if (allHubsTo && allHubsTo.data && allHubsTo.data.length) {
      return [
        selectedFleetsTo?.length && {
          label: "All",
          value: "all",
        },
        {
          label: "Clear",
          value: "clear",
        },
        ...(selectedFleetsTo?.includes("all") ? 
        allHubsTo?.data?.length &&
          allHubsTo?.data
            ?.map((hub) => {
              return {
                value: hub._id,
                label: hub.hubName,
              };
            }) : 
        allHubsTo?.data?.length &&
          allHubsTo?.data
            ?.filter((hub) => {
              const selectedFleetsVal = allFleetsTo?.data?.filter((fleet) =>
                selectedFleetsTo?.includes(fleet._id)
              );

              return selectedFleetsVal?.some(
                (fleet) => fleet.fleetCode === hub.fleetCode
              );
            })
            ?.map((hub) => {
              return {
                value: hub._id,
                label: hub.hubName,
              };
            })),
      ];
    }
  }, [allHubsTo, allFleetsTo, selectedFleetsTo]);

  const debouncedValue = useDebounce(search, 1000);

  const updateRecord = async (id, status) => {
    const myPromise = updateDocumentByID("/tyre/externalStockTransfer", id, {
      status: status,
    });

    toast.promise(myPromise, {
      loading: "Updating your request",
      success: async (dt) => {
        console.log(dt);
        await getData();
        setTransferTyres(null);
        return dt.message;
      },
      error: (err) =>
        err?.response?.data.error ||
        err?.response?.data.message ||
        err?.message ||
        "Something went wrong",
    });

    setTransferTyres(null);
  };

  const performTransfer = async (id, values) => {
    try {
      const myPromise = createDocument("/tyre/stockTransfer", {
        id,
        type: "EXTERNAL",
        ...values,
      });

      toast.promise(myPromise, {
        loading: "Updating your request",
        success: (dt) => {
          console.log(dt);
          if (dt.status === "fail") {
            return "fail";
          }
          getData();
          setTransferTyres(null);
          return `Successful`;
        },
        error: (err) =>
          err?.response?.data.error ||
          err?.response?.data.message ||
          err?.message ||
          "Something went wrong",
      });
    } catch (err) {
      console.log(err);
    }
  };

  return id ? (
    <>
      <div
        style={{ color: "black" }}
        className="justify-center items-center sm:w-full md:w-1/2 mx-auto text-center mt-10 font-medium text-gray-400 border border-gray-200 border-1 p-2 py-5"
      >
        <p>
          {" "}
          Please find the details of stock transfer of {
            request.tyres?.length
          }{" "}
          {request.tyres?.length == 1 ? "tyre" : "tyres"} from{" "}
          {request.fromHub?.hubName} to {request.toHub?.hubName} for following
          reason: {request.reason}
        </p>
        <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
            <div className=" overflow-hidden  sm:rounded-lg">
              <table className="mt-10  divide-y divide-gray-200 align-center justify-center mx-auto border border-gray-200 border-1">
                <thead className="bg-gray-50">
                  <tr>
                    <TH>Stencil Number</TH>
                    <TH>Brand</TH>
                    <TH>Size</TH>
                    <TH>NSD</TH>
                    <TH>Tyre Life</TH>
                    <TH>RUN KM</TH>
                  </tr>
                </thead>
                {request?.tyres?.map((item) => {
                  return (
                    <tr>
                      <td>{item?.stencilNo}</td>
                      <td>{item?.brand}</td>
                      <td>{item?.tyreSize}</td>
                      <td>{item?.averageNSD}</td>
                      <td>{item?.tyreType}</td>
                      <td>{item?.totalKillometerTravelled}</td>
                    </tr>
                  );
                })}
              </table>
            </div>
          </div>
        </div>
        <br />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "50px",
          }}
        >
          {request.status === "REQUESTED" ? (
            <>
              {searchParams.get("action") === "APPROVE" && (
                <button
                  onClick={() => {
                    updateRecord(searchParams.get("_id"), "APPROVED");
                  }}
                  style={{
                    background: "green",
                    padding: "7px",
                    margin: "7px",
                    borderRadius: "4px",
                  }}
                  className={`${"text-white"}`}
                >
                  {" "}
                  Approve{" "}
                </button>
              )}
              {searchParams.get("action") === "REJECT" && (
                <button
                  onClick={() => {
                    updateRecord(searchParams.get("_id"), "REJECTED");
                  }}
                  style={{
                    background: "red",
                    padding: "7px",
                    margin: "7px",
                    borderRadius: "4px",
                  }}
                  className={`${"text-white"}`}
                >
                  {" "}
                  Reject{" "}
                </button>
              )}
            </>
          ) : (
            <>Request is already {request.status}</>
          )}
        </div>
      </div>
    </>
  ) : (
    <div className="flex flex-col">
      <div className="mx-10 my-2">
        <div className="mt-8 flex flex-row justify-start gap-6 items-center">
          <div className="flex flex-col w-full">
            <div className="w-full grid grid-cols-4 gap-2">
              <label className="w-full py-3">
                Select Fleets
                <ReactSelect  
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      borderColor: "transparent",
                      minWidth: "100%",
                      "&:hover": {
                        borderColor: "rgb(34 197 94)",
                      },
                    }),
                  }}
                  className="shadow-md rounded-md py-1 mb-2"
                  options={getFleetOptions()}
                  value={
                    selectedFleets &&
                    selectedFleets?.map((fleet) => {
                      return {
                        value: fleet,
                        label: getFleetOptions()?.find((item) => item?.value === fleet)
                          ?.label,
                      };
                    })
                  }
                  onChange={(value) => {
                    let allValues = value?.map((item) => item.value);
                    if(allValues?.includes("clear")){
                      // console.log(allValues)
                      setSelectedFleets([]);
                      setSelectedHubs([]);
                      return;
                    }
                    if(!selectedFleets?.includes("all") && allValues.includes("all")){
                      setSelectedFleets(["all"]);
                      return;
                    }

                    if (selectedFleets.includes("all")) {
                      // console.log("first");
                      // console.log(getFleetOptions())
                      value = value.filter(item => item.value!== "all")
                    }

                    let selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                      value?.map((item) => item.value)?.includes(fleet._id)
                    );

                    let selectedHubsVal = allHubs?.data?.filter((hub) =>
                      selectedHubs?.map((item) => item)?.includes(hub._id)
                    );
                    
                    setSelectedHubs(
                      selectedHubsVal
                        ?.filter((hub) =>
                          selectedFleetsVal?.find(
                            (fleet) => fleet.fleetCode === hub.fleetCode
                          )
                        )
                        .map((hub) => hub._id)
                    );

                    // console.log({allHubs, selectedHubs})
                    
                    setSelectedFleets(value.map((fleet) => fleet.value));
                    }
                }
                  name="fleets"
                  isMulti = {true}
                />
              </label>
              <label className="w-full py-3">
                Select Hubs
                <ReactSelect
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      borderColor: "transparent",
                      minWidth: "100%",
                      "&:hover": {
                        borderColor: "rgb(34 197 94)",
                      },
                    }),
                  }}
                  className="shadow-md rounded-md py-1 mb-2"
                  options={getHubOptions()}
                  value={
                    selectedHubs &&
                    selectedHubs?.map((hub) => {
                      // console.log({hub})
                      return {
                        value: hub,
                        label: getHubOptions()?.find((item) => item.value === hub)
                          ?.label,
                      };
                    })
                  }
                  onChange={(value) => {
                    const allValues = value?.map((item) => item.value);
                    // console.log({allValues})
                    if(allValues.includes("clear")){
                      setSelectedHubs([])
                      return;
                    }
                    if (!selectedHubs?.includes("all") && allValues.includes("all")) {
                      let selectedFleetCodes = allFleets?.data?.filter((fleet) =>
                        selectedFleets?.includes(fleet._id)
                      )?.map(fleet=>fleet.fleetCode);

                      const selectedHubsData = allHubs?.data?.filter(hub=> selectedFleetCodes?.includes(hub.fleetCode))

                      const mp = fleetMap;
                      selectedHubsData.map(hub=>{
                        if(selectedFleetCodes?.includes(hub.fleetCode)){
                        if(mp[hub.fleetCode] === undefined) mp[hub.fleetCode] = [];
                        mp[hub.fleetCode] = [...mp[hub.fleetCode], hub._id]
                      }})

                      setFleetMap(mp);
                      setSelectedHubs(["all"])
                    } 
                    else {
                      // console.log({value})
                      value = value.filter(value => value.value!== "all")
                      // console.log({value})
                      let selectedFleetCodes = allFleets?.data?.filter((fleet) =>
                        selectedFleets?.includes(fleet._id)
                      )?.map(fleet=>fleet.fleetCode);
                      // console.log({allValues})
                    
                      const selectedHubsData = allHubs?.data?.filter(hub=> allValues?.includes(hub._id))
                      const mp = {};
                      selectedHubsData.map(hub=>{
                        mp[hub.fleetCode] = [];
                      })

                      selectedHubsData.map(hub=>{
                        if(selectedFleetCodes?.includes(hub.fleetCode)){
                        if(mp[hub.fleetCode] === undefined) mp[hub.fleetCode] = [];
                        mp[hub.fleetCode] = [...mp[hub.fleetCode], hub._id]
                      }})

                      setFleetMap(mp);                  
                      setSelectedHubs(value.map((hub) => hub.value));
                    }
                  }}
                  name="hubs"
                  isMulti={true}
                />
              </label>
              <label className="w-full py-3" htmlFor="contractType">
                         Contract Type 
                        <Select
                            name="contractType"
                            value={contractType}
                            onChange={(e) => setContractType(e.target.value)}
                        >
                            <option value={""}> All</option>
                            <option value={"CPKM"}>CPKM</option>
                            <option value={"NON CPKM"}>Non-CPKM/Service Contract</option>
                        </Select>
                    </label>

                    <label className="w-full py-3" htmlFor="stockTransferType">
                      Stock Transfer Type 
                        <Select
                            name="stockTransferType"
                            value={stockTransferType}
                            onChange={(e) => setStockTransferType(e.target.value)}
                        >
                            <option value={""}> All</option>
                            <option value={"INTERNAL"}> Internal</option>
                            <option value={"EXTERNAL"}>External</option>
                        </Select>
                    </label>
            </div>
            <div className="grid grid-cols-4 gap-2">
              <label className="col-span-2 lg:col-span-1 py-3 ">
                To Fleet
                <ReactSelect
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      borderColor: "transparent",
                      minWidth: "100%",
                      "&:hover": {
                        borderColor: "rgb(34 197 94)",
                      },
                    }),
                  }}
                  className="shadow-md rounded-md py-1 mb-2"
                  options={getToFleetOptions()}
                  value={
                    selectedFleetsTo &&
                    selectedFleetsTo?.map((fleet) => {
                      return {
                        value: fleet,
                        label: getToFleetOptions()?.find((item) => item?.value === fleet)
                          ?.label,
                      };
                    })
                  }
                  onChange={(value) => {
                    const allValues = value?.map((item) => item.value);
                    if(allValues?.includes("clear")){
                      // console.log(allValues)
                      setSelectedFleetsTo([]);
                      setSelectedHubsTo([]);
                      return;
                    }
                    if(!selectedFleetsTo?.includes("all") && allValues.includes("all")){
                      setSelectedFleetsTo(["all"]);
                      return;
                    }
                    if (selectedFleetsTo.includes("all")) {
                      // console.log("first");
                      // console.log(getFleetOptions())
                      value = value.filter(item => item.value!== "all")
                    }
                    let selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                      value?.map((item) => item.value)?.includes(fleet._id)
                    );

                    let selectedHubsVal = allHubsTo?.data?.filter((hub) =>
                      selectedHubsTo?.map((item) => item)?.includes(hub._id)
                    );
                    
                    setSelectedHubsTo(
                      selectedHubsVal
                        ?.filter((hub) =>
                          selectedFleetsVal?.find(
                            (fleet) => fleet.fleetCode === hub.fleetCode
                          )
                        )
                        .map((hub) => hub._id)
                    );

                    // console.log({allHubs, selectedHubs})
                    
                    setSelectedFleetsTo(value.map((fleet) => fleet.value));
                  }}
                  name="fleets"
                  isMulti={true}
                />
              </label>

              <label className="col-span-2 lg:col-span-1 py-3">
                To Hub
                <ReactSelect
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      borderColor: "transparent",
                      minWidth: "100%",
                      "&:hover": {
                        borderColor: "rgb(34 197 94)",
                      },
                    }),
                  }}
                  className="shadow-md rounded-md py-1 mb-2"
                  options={getToHubOptions()}
                  value={
                    selectedHubsTo &&
                    selectedHubsTo?.map((hub) => {
                      return {
                        value: hub,
                        label: getToHubOptions()?.find((item) => item.value === hub)
                          ?.label,
                      };
                    })
                  }
                  onChange={(value) => {
                    const allValues = value?.map((item) => item.value);
                    // console.log({allValues})
                    if(allValues.includes("clear")){
                      setSelectedHubsTo([])
                      return;
                    }
                    if (!selectedHubsTo?.includes("all") && allValues.includes("all")) {
                      let selectedFleetCodes = allFleetsTo?.data?.filter((fleet) =>
                        selectedFleetsTo?.includes(fleet._id)
                      )?.map(fleet=>fleet.fleetCode);

                      const selectedHubsData = allHubsTo?.data?.filter(hub=> selectedFleetCodes?.includes(hub.fleetCode))

                      const mp = fleetMap;
                      selectedHubsData.map(hub=>{
                        if(selectedFleetCodes?.includes(hub.fleetCode)){
                        if(mp[hub.fleetCode] === undefined) mp[hub.fleetCode] = [];
                        mp[hub.fleetCode] = [...mp[hub.fleetCode], hub._id]
                      }})

                      setFleetMap(mp);
                      setSelectedHubsTo(["all"])
                    } 
                    else {
                      // console.log({value})
                      value = value.filter(value => value.value!== "all")
                      // console.log({value})
                      let selectedFleetCodes = allFleetsTo?.data?.filter((fleet) =>
                        selectedFleetsTo?.includes(fleet._id)
                      )?.map(fleet=>fleet.fleetCode);
                      // console.log({allValues})
                    
                      const selectedHubsData = allHubsTo?.data?.filter(hub=> allValues?.includes(hub._id))
                      const mp = {};
                      selectedHubsData.map(hub=>{
                        mp[hub.fleetCode] = [];
                      })

                      selectedHubsData.map(hub=>{
                        if(selectedFleetCodes?.includes(hub.fleetCode)){
                        if(mp[hub.fleetCode] === undefined) mp[hub.fleetCode] = [];
                        mp[hub.fleetCode] = [...mp[hub.fleetCode], hub._id]
                      }})

                      setFleetMap(mp);                  
                      setSelectedHubsTo(value.map((hub) => hub.value));
                    }
                  }}
                  name="hubs"
                  isMulti={true}
                />
              </label>

              <label className="w-full py-3">
                Start Date{" "}
                <Input
                  type="date"
                  max={getFormattedDate()}
                  name="dateFrom"
                  value={dateFrom}
                  onChange={(e) => setDateFrom(e.target.value)}
                />
              </label>
              <label className="w-full py-3">
                End Date{" "}
                <Input
                  type="date"
                  min={getFormattedDate(dateFrom)}
                  name="dateTo"
                  value={dateTo}
                  onChange={(e) => setDateTo(e.target.value)}
                />
              </label>
            </div>
          </div>
          {/* <div className=" w-1/2 flex flex-col">
            <div className="w-full  flex flex-col justify-start items-center gap-y-5 gap-x-2 py-3">
              <label className="w-full">
                Start Date{" "}
                <Input
                  type="date"
                  max={getFormattedDate()}
                  name="dateFrom"
                  value={dateFrom}
                  onChange={(e) => setDateFrom(e.target.value)}
                />
              </label>
              <label className="w-full">
                End Date{" "}
                <Input
                  type="date"
                  min={getFormattedDate(dateFrom)}
                  name="dateTo"
                  value={dateTo}
                  onChange={(e) => setDateTo(e.target.value)}
                />
              </label>
            </div>
            <div className="flex flex-col gap-y-10"></div>
          </div> */}
        </div>

        <div className= "float-right flex flex-row gap-4">
          <Button
            type="button"
            bgPrimary
            onClick={async () => {
              setPage(1);
              await getData();
            }}
            disabled={
              (selectedHubs.length === 0 && selectedHubsTo.length === 0) &&
              !search
            }
          >
            Search
          </Button>
          {downloading ? 'Downloading...' : !((selectedHubs.length === 0 && selectedHubsTo.length === 0) &&
              !search) &&  <BiCloudDownload
          className="w-10 h-10 text-green-500 hover:scale-105 cursor-pointer text-center"
          onClick={() => {
            getData(1, true)
          }}
        />}
        </div>
        
      </div>
      {loading ? (
        <Spinner />
      ) : (
        <div className="flex flex-col m-2 lg:m-2">
          <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
              <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr className="py-2">
                      <TH scope="col">S.N.</TH>
                      <TH scope="col">Created At Time</TH>
                      <TH scope="col">From Fleet</TH>
                      <TH scope="col">From Hub</TH>
                      <TH scope="col">To Fleet</TH>
                      <TH scope="col">To Hub</TH>
                      <TH scope="col">Number of Tyres</TH>
                      <TH scope="col">Updated By</TH>
                      <TH scope="col">Status</TH>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {data?.data &&
                      data.data.map((item, index) => (
                        <ViewList
                          data={item}
                          key={item?._id}
                          index={index}
                          page={page}
                          setModalData={setModalData}
                          getData={getData}
                          updateRecord={updateRecord}
                          setTransferTyres={setTransferTyres}
                          currentUser={currentUser}
                        />
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {data && data.paginate && data.paginate.total && (
            <div className="container mx-auto flex justify-center items-center gap-2 py-5">
              <Button
                onClick={() => {
                  setPage((p) => Math.max(p - 1, 1));
                }}
                disabled={page === 1}
                className="disabled:pointer-events-none disabled:opacity-70 px-0 "
                primary
              >
                <div className="flex gap-1 items-center">
                  <IoMdArrowBack />
                  Prev Page
                </div>
              </Button>
              <span className="text-gray-600 px-4">{`showing: ${
                (page - 1) * 20 + 1
              } - ${Math.min(data?.paginate?.total, page * 20)} of ${
                data.paginate.total
              }`}</span>

              {data.paginate.total > page * 20 && (
                <Button
                  onClick={() => {
                    setPage((p) => Math.min(p + 1, data?.paginate?.total));
                  }}
                  disabled={page === data?.paginate?.total}
                  className="disabled:pointer-events-none disabled:opacity-70 px-0 "
                  primary
                >
                  <div className="flex gap-1 items-center">
                    Next Page
                    <IoMdArrowForward />
                  </div>
                </Button>
              )}
            </div>
          )}

        </div>
      )}
      {modalData && (
        <Modal
          handleClick={() => {
            setModalData(null);
          }}
          title="Stock Transfer Info"
        >
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr className="py-2">
                <TH scope="col">S.N.</TH>
                <TH scope="col">Stencil Number</TH>
                <TH scope="col">Tyre Type</TH>
                <TH scope="col">Average NSD</TH>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {modalData &&
                modalData.map((item, index) => (
                  <ViewTyreList
                    data={item}
                    key={item?._id}
                    index={index}
                    setModalData={setModalData}
                  />
                ))}
            </tbody>
          </table>
        </Modal>
      )}

      {transferTyres && (
        <Modal
          handleClick={() => {
            setTransferTyres(null);
          }}
          className="w-64"
          title="Stock Transfer Info"
        >
          <TransferTyres
            data={transferTyres}
            // key={item?._id}
            // index={index}
            setModalData={setModalData}
            performTransfer={performTransfer}
          />
        </Modal>
      )}
    </div>
  );
};

export default ExternalStockTansferReport;

const ViewTyreList = ({ data, index, setModalData, performTransfer }) => {
  return (
    <tr key={data._id} className={`${index % 2 !== 0 && "bg-gray-100"} h-10`}>
      <TD>{index + 1}</TD>
      <TD>{data.stencilNo}</TD>
      <TD>{data.tyreType  ?? "ITM"}</TD>
      <TD> <div className="text-center">{data.averageNSD ?? data.originalNSD}</div></TD>
    </tr>
  );
};

const TransferTyres = ({ data, index, setModalData, performTransfer }) => {
  // const [discount]
  const [values, setValues] = useState([]);
  const [disabled, setDisabled] = useState(true);
  useEffect(() => {
    console.log({ data });
    const tmp = data?.tyres?.map((item) => {
      return { ...item, amount: 0, discount: 0 };
    });
    setValues([...tmp]);
    formik.setValues({ tyres: [...tmp] });
  }, [data]);

  const formik = useFormik({
    initialValues: {
      tyres: values,
    },
    onSubmit: async (values) => {
      try {
        console.log(values.tyres);
        performTransfer(data._id, { ...data, tyres: values.tyres });
      } catch (error) {
        console.log({ error });
        toast.error(
          error?.response?.data?.message ||
            error?.response?.data?.error ||
            "Something went wrong"
        );
      }
    },

    validate: (values) => {
      let errors = {
        tyres: [
          ...values?.tyres?.map((tyre) => {
            return { discount: "", afterDiscount: "" };
          }),
        ],
      };

      values.tyres.map((tyre, index) => {
        if (parseInt(tyre.discount) > 99) {
          errors.tyres[index].discount = "Please enter value < 100";
          errors.tyres[index].afterDiscount = "cannot be -ve";
        } else {
          delete errors.tyres[index];
        }
      });
      if (!errors.tyres[0]) {
        errors.tyres = null;
      }
      console.log({ errors, values });
      setDisabled(errors?.tyres);
      return errors;
    },
  });

  useEffect(() => {}, [disabled]);

  return (
    <FormikProvider value={formik}>
      <Form>
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr className="py-2">
              <TH scope="col">S.N.</TH>
              <TH scope="col">Stencil Number</TH>
              <TH scope="col">Brand</TH>
              <TH scope="col">Size</TH>
              <TH scope="col">NSD</TH>
              <TH scope="col">Tyre Life</TH>
              <TH scope="col">NDP TYre</TH>
              <TH scope="col">NDP Tube</TH>
              <TH scope="col">NDP Flap</TH>
              <TH scope="col">Amount</TH>
              <TH scope="col">Discount (%)</TH>
              <TH scope="col">After Discount</TH>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {formik.values &&
              formik.values?.tyres?.map((item, index) => {
                const NDP = parseFloat(
                  parseFloat(item.NDPTyre ?? 0) +
                    parseFloat(item.NDPTube ?? 0) +
                    parseFloat(item.NDPFlap ?? 0)
                ).toFixed(2);
                const amount = parseFloat(
                  (NDP / item.originalNSD) * item.averageNSD
                ).toFixed(2);
                return (
                  <tr
                    key={item._id}
                    className={`${index % 2 !== 0 && "bg-gray-100"} h-10`}
                  >
                    <TD>{index + 1}</TD>
                    <TD>{item.stencilNo}</TD>
                    <TD>{item.brand}</TD>
                    <TD>{item.tyreSize}</TD>
                    <TD>{item.averageNSD}</TD>
                    <TD>{item.tyreType}</TD>
                    <TD>{item.NDPTyre ?? "---"}</TD>
                    <TD>{item.NDPTube ?? "---"}</TD>
                    <TD>{item.NDPFlap ?? "---"}</TD>
                    <TD>{amount}</TD>
                    <TD>
                      <Input
                        type="number"
                        formik={formik}
                        // value= {formik.values.tyres[index]?.discount}
                        name={`tyres[${index}].discount`}
                        dissabled={!(item.originalNSD || item.averageNSD)}
                        max={"100"}
                        min={"0"}
                        className="w-10"
                        onChange={(e) => {
                          const discount = e.target.value;
                          const afterDiscount = parseFloat(
                            (1 - 0.01 * discount) * amount
                          ).toFixed(2);
                          formik.setFieldValue(
                            `tyres[${index}].discount`,
                            e.target.value
                          );
                          formik.setFieldValue(
                            `tyres[${index}].afterDiscount`,
                            afterDiscount
                          );
                          formik.setFieldValue(
                            `tyres[${index}].amount`,
                            amount
                          );
                          // setValues(temp)
                        }}
                      ></Input>

                      <p className="text-red-500 flex">
                        {formik.errors?.tyres?.length &&
                        formik.errors.tyres[index]?.discount
                          ? formik.errors.tyres[index]?.discount + "*"
                          : ""}
                      </p>
                    </TD>
                    <TD>
                      {item.afterDiscount}
                      <p className="text-red-500 flex">
                        {formik.errors?.tyres?.length &&
                        formik.errors.tyres[index]?.afterDiscount
                          ? formik.errors.tyres[index]?.afterDiscount + "*"
                          : ""}
                      </p>
                    </TD>
                  </tr>
                );
              })}
          </tbody>
          <div className="flex justify-end">
            <Button
              disabled={disabled}
              primary
              className="mt-4 mx-2 py-2 h-12 justify-end float-right mr-0"
              onClick={async () => {
                try {
                  performTransfer(data._id, {
                    ...data,
                    tyres: formik.values.tyres,
                  });
                } catch (err) {
                  toast.message("error", err?.message);
                }
              }}
            >
              {" "}
              Transfer
            </Button>
          </div>
        </table>
      </Form>
    </FormikProvider>
  );
};

const ViewList = ({
  data,
  index,
  page,
  setModalData,
  setTransferTyres,
  updateRecord,
  currentUser,
}) => {
  const getDiv = (status) => {
    return (
      <div
        className={`${
          status === "REQUESTED"
            ? "text-blue-500"
            : status === "REJECTED"
            ? "text-red-500"
            : status === "APPROVED"
            ? "text-green-500"
            : "text-orange-500"
        } font-medium `}
      >
        {" "}
        {status}{" "}
      </div>
    );
  };

  return (
    <tr key={data._id} className={`${index % 2 !== 0 && "bg-gray-100"} h-10`}>
      <TD>{(page-1)*20 + index + 1}</TD>
      <TD>{convertToIndianTimezoneAndGetDate(data.createdAt)}</TD>
      <TD>{`${data.fromFleet} (${data.fromFleetCity ?? "-"})`}</TD>
      <TD>{data.fromHub}</TD>
      <TD>{`${data.toFleet} (${data.toFleetCity ?? "-"})`}</TD>
      <TD>{data.toHub}</TD>
      <TD
        className="stock-transfers-stencil-numbers text-green-500 hover:text-green-600 underline cursor-pointer font-semibold"
        onClick={() => {
          setModalData(data.tyres?.length ? data.tyres : data.stencilDetails)
        }}
      >
        {data.tyres?.length ? data.tyres?.length: data.stencilDetails?.length}
      </TD>
      <TD>{data.updatedBy && data.updatedBy ? data.updatedBy : "---"}</TD>
      <TD>{getDiv(data.status)}</TD>
    </tr>
  );
};